**Deprecated:** There is no guarantee all profiles will be returned. Use `paginatedPositionProfiles` instead.
